import React from 'react'
import { ContHeader, PageTitle } from '../../../../../assets/css/components/admin/marketplace-to-marketplace/GridListProducts/GridListProducts'

export default function HeaderGrid() {
    return (
        <ContHeader>
            <PageTitle>Productos</PageTitle>
        </ContHeader>

    )
}
